import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Card from 'components/card/Card'
import Button from 'components/button/Button'
import { Typography } from 'antd'
import Badge, { TVariant } from 'components/badge/Badge'
import CampaignProgramTable from './CampaignDetailTable'
import { CampaignsProgramsGetDetailParticipantsInner } from 'generated/api'
import dayjs from 'dayjs'
import { useCampaign } from '../hooks/useCampaignCreation'

type StatusInfo = {
  translation: string
  type: string
}

const CampaignDetail: React.FC = () => {
  const { getCampaignDetail, detailCampaign } = useCampaign()
  // const mockData: CampaignsProgramsGetDetailRequest & { status: string } = {
  //   id: '2ced2567-5980-4e3b-b68c-d3ffdb99d9d9',
  //   name: 'Panen Emas 1.0 ke PT INTI INDOSAWIT SUBUR - PMKS BUATAN I',
  //   partnerId: 'ea9e0f71-43ba-4a1a-b0a3-a15ce470f626',
  //   partnerName: 'PT INTI INDOSAWIT',
  //   version: 2,
  //   startTime: 1714525200000,
  //   endTime: 1717117200000,
  //   createdAt: 1714471505000,
  //   totalParticipants: 15,
  //   participantCandidates: [],
  //   status: 'FINISHED',
  //   participants: [
  //     {
  //       campaignGoldId: 'ab08205a-caf8-4b17-8008-c137f347e320',
  //       userId: '277f7b1c-35d8-43bb-8af5-02e21e7e32d3',
  //       userName: 'Saka Ardianto',
  //       createdAt: 1714471505000,
  //       targets: [
  //         {
  //           type: 'DAILY',
  //           targetFfbWeightTonne: 500,
  //           startTime: 1714525200000,
  //           endTime: 1717117200000,
  //         },
  //         {
  //           type: 'MONTHLY',
  //           targetFfbWeightTonne: 1500,
  //           startTime: 1714525200000,
  //           endTime: 1717117200000,
  //         },
  //         {
  //           type: 'DAILY',
  //           targetFfbWeightTonne: 600,
  //           startTime: 1717223456000,
  //           endTime: 1719729056000,
  //         },
  //         {
  //           type: 'MONTHLY',
  //           targetFfbWeightTonne: 1700,
  //           startTime: 1717223456000,
  //           endTime: 1719729056000,
  //         },
  //         {
  //           type: 'DAILY',
  //           targetFfbWeightTonne: 700,
  //           startTime: 1719815456000,
  //           endTime: 1722321056000,
  //         },
  //         {
  //           type: 'MONTHLY',
  //           targetFfbWeightTonne: 2000,
  //           startTime: 1719815456000,
  //           endTime: 1722321056000,
  //         },
  //         {
  //           type: 'QUARTERLY',
  //           targetFfbWeightTonne: 5000,
  //           startTime: 1714525200000,
  //           endTime: 1717117200000,
  //         },
  //       ],
  //     },
  //     {
  //       campaignGoldId: 'ab08205a-caf8-4b17-8008-c137f347e320',
  //       userId: '277f7b1c-35d8-43bb-8af5-02e21e7e3dd3',
  //       userName: 'Ujang',
  //       createdAt: 1714471505000,
  //       targets: [
  //         {
  //           type: 'DAILY',
  //           targetFfbWeightTonne: 700,
  //           startTime: 1714525200000,
  //           endTime: 1717117200000,
  //         },
  //         {
  //           type: 'MONTHLY',
  //           targetFfbWeightTonne: 2000,
  //           startTime: 1714525200000,
  //           endTime: 1717117200000,
  //         },
  //         {
  //           type: 'DAILY',
  //           targetFfbWeightTonne: 800,
  //           startTime: 1717223456000,
  //           endTime: 1719729056000,
  //         },
  //         {
  //           type: 'MONTHLY',
  //           targetFfbWeightTonne: 2200,
  //           startTime: 1717223456000,
  //           endTime: 1719729056000,
  //         },
  //         {
  //           type: 'DAILY',
  //           targetFfbWeightTonne: 1000,
  //           startTime: 1719815456000,
  //           endTime: 1722321056000,
  //         },
  //         {
  //           type: 'MONTHLY',
  //           targetFfbWeightTonne: 3000,
  //           startTime: 1719815456000,
  //           endTime: 1722321056000,
  //         },
  //         {
  //           type: 'QUARTERLY',
  //           targetFfbWeightTonne: 8000,
  //           startTime: 1714525200000,
  //           endTime: 1717117200000,
  //         },
  //       ],
  //     },
  //   ],
  // }
  const { id } = useParams()

  useEffect(() => {
    id && getCampaignDetail()
  }, [id])

  function getStatusInfo(status: string) {
    const statusMapping: { [key: string]: StatusInfo } = {
      SCHEDULED: { translation: 'Dijadwalkan', type: 'warning' },
      ONGOING: { translation: 'Berjalan', type: 'info' },
      FINISHED: { translation: 'Selesai', type: 'success' },
    }

    if (status in statusMapping) {
      return statusMapping[status]
    } else {
      return { translation: 'Selesai', type: 'success' }
    }
  }

  const convertUser = () => {
    return detailCampaign.participantsExtend.map(data => {
      return {
        campaignGoldId: data.campaignGoldId,
        userId: data.id,
        userName: data.name,
        targets: data.targets,
        createdAt: data.createdAt,
      } as CampaignsProgramsGetDetailParticipantsInner
    })
  }
  return (
    <div className="content-wrapper">
      <Card className="p-6" dataTestId="card-detail-wrapper">
        <Card.Body className="m-0">
          <div className="flex flex-row justify-between">
            <div className="flex flex-1 flex-col">
              <Typography className="font-bold text-xl">{detailCampaign.name}</Typography>
              <Typography className="text-xs my-2">
                {dayjs(detailCampaign.createdAt).format('DD MMM YYYY, HH:mm')}
              </Typography>
              <div className="w-[100px]">
                <Badge
                  title={getStatusInfo(detailCampaign.status ?? '').translation}
                  variant={getStatusInfo(detailCampaign.status ?? '').type as TVariant}
                />
              </div>
            </div>
            <div className="flex flex-row flex-2 h-[44px]" data-testid="buttons-header">
              <Button variant="outline-primary" className="mr-4 font-bold text-sm">
                Tambah Peserta
              </Button>
              <Button variant="outline-primary" className="font-bold text-sm">
                Tambah Target
              </Button>
            </div>
          </div>
          <div
            className="flex-1 rounded-lg border-[#E5E5E7] border border-solid py-[12px] px-[16px] my-4"
            data-testid="information-agen"
          >
            <Typography className="font-semibold text-base mb-2">Informasi Program Agen</Typography>
            <div className="flex flex-row justify-between">
              <div className="flex-col">
                <Typography className="font-normal text-sm">Nama Pabrik:</Typography>
                <Typography className="font-normal text-sm my-2">Jenis Program:</Typography>
                <Typography className="font-normal text-sm">Tanggal Program:</Typography>
              </div>
              <div className="flex-col">
                <Typography className="font-semibold text-sm text-end">
                  {detailCampaign.partnerName}
                </Typography>
                <Typography className="font-semibold text-sm my-2 text-end">
                  Panen Emas v.{detailCampaign.version}.0
                </Typography>
                <Typography className="font-semibold text-sm text-end">
                  {dayjs(detailCampaign.startTime).format('DD MMM YYYY, HH:mm')}
                  {' - '}
                  {dayjs(detailCampaign.endTime).format('DD MMM YYYY, HH:mm')}
                </Typography>
              </div>
            </div>
          </div>
          <CampaignProgramTable data={convertUser()} detailCampaign={detailCampaign} />
        </Card.Body>
      </Card>
    </div>
  )
}

export default CampaignDetail
